export const filterDriversVehiclesMetadata = [
  {
    name: 'driverName',
    type: 'string',
    title: 'Driver name',
  },
];
